export default __webpack_public_path__ + "static/media/Reader's Arm-straps of the Moon.85005819.jpg";